exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gift-show-description[data-v-ac792aa4] {\n  color: #11bb2e;\n  margin-top: 5px;\n}\n.mb5[data-v-ac792aa4] {\n  margin-bottom: 5px;\n}\n.gift-block-button-add-to-cart[data-v-ac792aa4] {\n  padding: 10px;\n}\n", ""]);

// exports
